import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "../../theme";
import { H1 } from "../../text";
import { useBlockComponentContext } from "../index";
import { ADAPTABLE_TEXT_CLASSNAME } from "../index";
export const BlockTitle = ({ id, translationKey, horizontalAlignment, Title: DefaultTitle, }) => {
    const { Title = DefaultTitle, Markdown, Translated, } = useBlockComponentContext();
    return (_jsx(Title, { id: id, className: ADAPTABLE_TEXT_CLASSNAME, horizontalAlignment: horizontalAlignment, children: _jsx(Translated, { translationKey: translationKey, render: ({ translation }) => _jsx(Markdown, { source: translation }) }) }));
};
export const Title = styled(H1) `
  font-size: 2.625em;
  line-height: 1.5em;
  margin-top: 10px;
  margin-bottom: 15px;
  text-align: ${({ horizontalAlignment }) => horizontalAlignment};
`;
BlockTitle.defaultProps = {
    horizontalAlignment: "left",
    Title,
};
